

/* eslint-disable react/no-unescaped-entities */
import React,{useEffect, useState} from 'react';
import { Flex } from '@baont0209/pibridge_uikit_v20';
import PageFullWidth from 'components/Layout/PageFullWidth';
import { SharePiIcon } from 'components/Pancake-uikit';
import styled from 'styled-components';
import axios from 'axios';
import CardTime from './components/CardTime';
import HeaderPiBridge from './components/HeaderPiBridge';
import TotalWhiteList from './components/TotalWhiteList';
import WhiteList from './components/WhiteList';
// import { Body, ColLeft, ColRight, CSContainer, Row, RowLayout, RowLink, TextHead, TextHeadLink, TextLink, TextLinkPiBridge} from './styles';
import { Body, ColLeft, ColRight, CSContainer, Row, RowLayout, RowLinkPc, TextHead, TextHeadLink, TextHeadLinkPi, TextLink} from './styles';

const HomePi = () => {

    const [isOpenTooltip, setOpenTooltip] = useState(false);

    const addressPiBridge = "https://tofunft.com/collection/pibridge-tesseract-nft/items";

    function openLink(){
        window.open("https://tofunft.com/collection/pibridge-tesseract-nft/items");
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(addressPiBridge);
            setOpenTooltip(!false);
            setTimeout(() => {
                setOpenTooltip(false);
            }, 3000);
    }
    
    // eslint-disable-next-line consistent-return
    function linkPiBridgeFc(linkPiBridge: any) {
        const linkPiBridgeShort = linkPiBridge ? `${linkPiBridge.substring(0, 46)}...` : null;
        const linkPiBridgeShort600 = linkPiBridge ? `${linkPiBridge.substring(0, 30)}...` : null;
        if (window.screen.width <= 600) {
            return (
                linkPiBridgeShort600
            )
        } 
        if (window.screen.width <= 768) {
            return (
                linkPiBridgeShort
            )
        } 
        return linkPiBridge;
    }

    return (
        <PageFullWidth>
            <HeaderPiBridge />
            <Body>
                <CSContainer>
                    <RowLayout>
                        <ColLeft>
                           <Row mb='20px'>
                                {/* Total WhiteList */}
                                <TotalWhiteList />
                           </Row>
                           <RowLinkPc alignContent='center' mb='50px'>
                               <TextHeadLink color='#494949'>TofuNFT link:</TextHeadLink>
                               <Flex position='relative'>
                                    <TextHeadLinkPi onClick={openLink}>{linkPiBridgeFc(addressPiBridge)}</TextHeadLinkPi>
                                    <SharePiIcon onClick={handleCopy} width='40px' cursor='pointer'/>
                                    <Tooltip isTooltipDisplayed={isOpenTooltip}>Copied</Tooltip>
                               </Flex>
                           </RowLinkPc>
                           {/* WhiteList */}
                           { window.screen.width > 1024 &&   <WhiteList marginTop='0px'/> }
                         
                        </ColLeft>
                        <ColRight>
                            {/* Time Event */}
                           <CardTime />
                           { window.screen.width <= 1024 && <WhiteList marginTop='80px'/> }
                           
                        </ColRight>
                    </RowLayout>
                </CSContainer>
            </Body>
        </PageFullWidth>
    );
};

export default HomePi;


const Tooltip = styled.div<{ isTooltipDisplayed: boolean }>`
  display: ${({ isTooltipDisplayed }) => (isTooltipDisplayed ? 'inline-block' : 'none')};
  position: absolute;
  padding: 8px;
  top: -35px;
  right: -15px;
  text-align: center;
  background-color: #fff;
  color: #000;
  border-radius: 16px;
  width: 100px;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.1);
`